import React from "react";

export default function CGV() {
  return (
    <section className="bg-white py-14 lg:py-20 px-6 lg:px-10" data-testid="legal-cgv">
      <div className="max-w-3xl mx-auto">
        <p className="text-fegreen font-medium uppercase tracking-[0.25em] text-xs mb-3">— Conditions de vente</p>
        <h1 className="text-3xl lg:text-5xl font-bold text-fegray-dark mb-10">Conditions Générales de Vente</h1>

        <div className="prose prose-sm lg:prose-base max-w-none text-fegray space-y-8">
          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Article 1 — Objet</h2>
            <p>
              Les présentes Conditions Générales de Vente (CGV) régissent les relations
              contractuelles entre FORM'ELEC (Rosalie Riveti, ci-après « le Prestataire ») et
              tout client (ci-après « le Client ») pour les prestations de coaching sportif à
              domicile, séances d'électrostimulation (EMS) et soins de massage proposés.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Article 2 — Prestations</h2>
            <p>
              Le Prestataire propose : séances individuelles d'électrostimulation (EMS) à domicile,
              séances de drainage lymphatique, massages récupération, palper-rouler, soins prénatals
              et post-partum. Les tarifs en vigueur sont indiqués sur la page <strong>Nos Tarifs</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Article 3 — Réservation &amp; paiement</h2>
            <p>
              La réservation s'effectue en ligne via le site formelec ou par téléphone. Le paiement
              est sécurisé via Stripe. Les prestations relevant des Services à la Personne (SAP)
              ouvrent droit au <strong>crédit d'impôt de 50%</strong>, sous réserve de remplir les
              conditions URSSAF (compte fiscal, RIB français, déclaration de revenus à jour).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Article 4 — Annulation &amp; report</h2>
            <ul className="list-disc pl-5 space-y-1.5">
              <li>Annulation gratuite jusqu'à <strong>24 heures avant</strong> la séance.</li>
              <li>Annulation entre 24h et 12h : la séance est facturée à <strong>50%</strong>.</li>
              <li>Annulation à moins de 12h ou no-show : la séance est <strong>due intégralement</strong>.</li>
              <li>Report possible une fois par séance, sous réserve de disponibilités.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Article 5 — Validité des packs</h2>
            <p>
              Les packs (5, 10, 20 séances) sont valables <strong>12 mois</strong> à compter de la
              date d'achat. Aucun remboursement de séances non consommées au-delà de cette période,
              sauf cas de force majeure (avis médical).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Article 6 — Contre-indications</h2>
            <p>
              L'électrostimulation est <strong>déconseillée</strong> aux porteurs de pacemaker,
              femmes enceintes, épileptiques, et personnes présentant certaines pathologies cardiaques
              ou cutanées. Le Client s'engage à informer le coach de tout antécédent médical avant
              la première séance et à fournir un certificat médical de non-contre-indication si requis.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Article 7 — Droit de rétractation</h2>
            <p>
              Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation
              ne peut être exercé pour les prestations d'EMS et de massage <strong>pleinement
              exécutées avant la fin du délai de 14 jours</strong>, avec accord exprès du Client.
              Pour les séances non encore commencées, le délai de 14 jours s'applique.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Article 8 — Responsabilité &amp; assurance</h2>
            <p>
              FORM'ELEC dispose d'une assurance responsabilité civile professionnelle.
              Le Client s'engage à signaler tout incident dans les 48h suivant la séance.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">Article 9 — Litiges</h2>
            <p>
              Les présentes CGV sont régies par le droit français. En cas de litige, le Client peut
              recourir gratuitement au médiateur de la consommation
              (<a href="https://www.economie.gouv.fr/mediation-conso" target="_blank" rel="noreferrer" className="text-fegreen font-semibold underline">economie.gouv.fr/mediation-conso</a>)
              avant toute action en justice.
            </p>
          </section>
        </div>
      </div>
    </section>
  );
}
